import React, { useEffect, useState } from "react";
import { Header } from "../header";
import { useLocation, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { indexStore } from "../../store/indexStore";
import { BrowseProducts } from "./Tools";
import Iterator from "../utils/Iterator";
import OrderElement from "./OrderElement/OrderElement";
import OrderDetiles from "./OrderElement/OrderDetiles";
import Visibility from "../utils/Visibility";
import { Sheet, SheetContent, SheetTrigger } from "../ui/sheet";
import { Skeleton } from "../ui/skeleton";
import IsNotActive from "../IsNotActive/IsNotActive";
import { OrderModel } from "../../Models/OrderModel";
import { Button } from "../ui/button";

function Orders() {
  const params = useParams();
  const { t } = useTranslation();
  const {
    fetchOrdersAction,
    orders,
    style,
    getStyle,
    showOrderAction,
    restaurant,
    fetchBranchesAction,
    name,
    ordersLoading,
    orderLoading,
    order,
  } = indexStore();
  const tokenOrder = localStorage.getItem("tokenOrder" + params.branch_id);
  const [showAll, setShowAll] = useState(true);
  const location = useLocation();
  useEffect(() => {
    // جلب النمط إذا لم يتم تحميله بعد
    if (Object.keys(style).length === 0) getStyle(params);

    // جلب بيانات الفرع إذا لم يتم تحميلها بعد
    if (Object.keys(restaurant).length === 0)
      fetchBranchesAction({ domain: params.domain });

    // دالة لجلب الطلبات (حسب showAll)
    const fetchOrdersNow = () => {
      if (tokenOrder) {
        fetchOrdersAction({
          phoneCustomer: tokenOrder,
          domain: params.domain,
          all: false,
        });
      }
    };

    // تنفيذ عند تحميل الصفحة أول مرة
    fetchOrdersNow();

    // تكرار التحديث كل 4 دقائق
    const intervalId = setInterval(() => {
      fetchOrdersNow();
    }, 240000); // 4 دقائق = 240000 مللي ثانية

    // معالجة حالة العودة من صفحة الدفع
    const searchParams = new URLSearchParams(location.search);
    const fromCheckout = searchParams.get("confirm_payment");
    if (fromCheckout === "true") {
      localStorage.removeItem(`cart${params.branch_id}`);
      window.dispatchEvent(new Event("cart-updated"));
    }

    // تنظيف عند مغادرة الصفحة
    return () => clearInterval(intervalId);
  }, [tokenOrder, params.domain, params.branch_id, showAll]); // مهم إدراج showAll هنا

  const handleOrderClick = (order: OrderModel) => {
    showOrderAction({ ...order });  
  };
  const handelShowAll = () => {
    setShowAll(!showAll);
    fetchOrdersAction({
      phoneCustomer: tokenOrder,
      domain: params.domain,
      all: true,
    });
  };

  return (
    <IsNotActive>
      <div className="flex flex-col flex-grow bg-background">
        <title>{params?.domain?.toUpperCase()}</title>
        <Header
          backgroundColorfull={true}
          url={`/${params.domain}/${params.branch_id}`}
        />
        <div className="flex flex-col mb-28 gap-4 md:gap-5">
          {/* Header */}
          <div className="bg-primary rounded-b-3xl p-4 md:p-5 pb-5 md:pb-6 shadow-lg opacity-0 animate-fadeIn">
            <div className="flex flex-row justify-between items-center gap-3">
              <h3 className="text-2xl md:text-3xl font-bold text-onPrimary">
                {t("gloabl.orders")}
              </h3>
              <BrowseProducts
                params={params}
                t={t}
                className={"!bg-onPrimary text-primary"}
              />
            </div>
          </div>

          {/* Orders List */}
          <div className="px-4 md:px-6">
            <Sheet>
              <Visibility visible={!ordersLoading}>
                <div className="flex flex-col gap-3 md:gap-4 opacity-0 animate-[fadeIn_0.3s_ease-out_0.2s_forwards]">
                  <Iterator
                    data={orders}
                    render={(e: OrderModel, i: number) => (
                      <div
                        key={e.id || i}
                        className="opacity-0 animate-fadeInUp"
                        style={{
                          animationDelay: `${i * 50}ms`,
                        }}
                      >
                        <SheetTrigger asChild>
                          <OrderElement
                            name={name}
                            t={t}
                            params={params}
                            order={e}
                            index={i}
                            tokenOrder={tokenOrder}
                            onClick={(order: OrderModel) => handleOrderClick(order)}
                          />
                        </SheetTrigger>
                      </div>
                    )}
                  />
                </div>
              </Visibility>
              <SheetContent
                side={"bottom"}
                className="flex flex-col gap-4 pb-20 bg-background max-h-[70vh] overflow-y-auto z-50"
              >
                <OrderDetiles
                  order={order}
                  t={t}
                  name={name}
                  loading={orderLoading}
                />
              </SheetContent>
            </Sheet>
          </div>

          {/* Show All Button */}
          <Visibility visible={showAll}>
            <div className="px-4 md:px-6 opacity-0 animate-[fadeIn_0.3s_ease-out_0.3s_forwards]">
              <Button
                onClick={handelShowAll}
                variant={"link"}
                className="text-primary hover:text-primary/80 font-semibold"
              >
                {t("gloabl.showAllOrders")}
              </Button>
            </div>
          </Visibility>

          {/* Loading State */}
          <Visibility visible={ordersLoading}>
            <div className="px-4 md:px-6 flex flex-col gap-3 md:gap-4">
              <Iterator
                data={[1, 2, 3]}
                render={(_, i) => (
                  <OrdersLoading key={i} />
                )}
              />
            </div>
          </Visibility>
        </div>
      </div>
    </IsNotActive>
  );
}

export default Orders;
const OrdersLoading = () => (
  <div className="border border-border p-4 md:p-5 rounded-xl shadow-md bg-card flex justify-between items-center">
    <div className="flex flex-col gap-2 md:gap-3 flex-1">
      <Skeleton className="w-48 md:w-56 h-6 md:h-7" />
      <Skeleton className="w-40 md:w-48 h-4" />
      <Skeleton className="w-44 md:w-52 h-4" />
      <Skeleton className="w-36 md:w-44 h-4" />
    </div>
    <Skeleton className="w-20 h-20 md:w-24 md:h-24 rounded-full flex-shrink-0" />
  </div>
);
